import React, { useEffect } from 'react';
import { Button, List, Spin } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import './styles.css';
import { RouteComponentProps } from 'react-router-dom';
import WebsiteCard from '../WebsiteCard/WebsiteCard';
import {
  useWebsiteList,
  useWebsitesFacade,
  useWebsitesStoreLoading,
  useWebsitesFetched,
} from '../../store/hooks';

const block = 'websites';

const Websites: React.FC<RouteComponentProps> = ({ history }) => {
  const facade = useWebsitesFacade();
  const websites = useWebsiteList();
  const isLoading = useWebsitesStoreLoading();
  const websitesFetched = useWebsitesFetched();

  useEffect(() => {
    if (!websitesFetched) {
      facade.loadAll();
    }
  }, [facade, websitesFetched]);

  const handleAddWebsite = () => {
    history.push('/admin/websites/create');
  };

  const handleEditWebsite = (id: string) => {
    history.push(`/admin/websites/edit/${id}`);
  };

  const handleViewStats = (id: string) => {
    history.push(`/admin/stats/${id}`);
  };

  const handleGetCode = (id: string) => {
    history.push(`/admin/websites/code/${id}`);
  };

  const handleRemove = (id: string) => {
    facade.delete(id);
  };

  const content = (
    <div className={block}>
      <div className={`${block}__header`}>
        <Button
          className={`${block}__add-btn`}
          size="large"
          type="primary"
          onClick={handleAddWebsite}
          icon={<PlusOutlined />}
        >
          Add website
        </Button>
      </div>
      <div className={`${block}__content`}>
        <List
          grid={{ gutter: 16, xs: 1, sm: 2, md: 3, lg: 4, xl: 5, xxl: 5 }}
          dataSource={websites}
          renderItem={(item) => (
            <List.Item>
              <WebsiteCard
                website={item}
                onEdit={handleEditWebsite}
                onViewStats={handleViewStats}
                onGetCode={handleGetCode}
                onRemove={handleRemove}
              />
            </List.Item>
          )}
        />
      </div>
    </div>
  );

  return isLoading ? <Spin>{content}</Spin> : content;
};

export default Websites;
